import { graphql } from 'react-relay';

export const compositionChartFragment = graphql`
  fragment CompositionChart_component on CompositionChart {
    data {
      name
      percent
      color
    }
    disclaimer
  }
`;
